/**
 * Insider Integration — Event Tracking
 * Uses InsiderQueue pattern with custom_event type.
 */

import { insiderConfig } from './insider.config';
import { queuePush, queueCommit } from './insider';
import { EInsiderQueueType } from './insider.types';
import type { RegistrationEventParams, ReservationEventParams } from './insider.types';

// Dedup sets — prevent double-click / StrictMode duplicates
const sentRegistrations = new Set<string>();
const sentReservations = new Set<string>();

/**
 * Track campaign-voucher_registration event.
 */
export function trackVoucherRegistration(params: RegistrationEventParams): void {
  if (!insiderConfig.enabled) return;
  if (sentRegistrations.has(params.cpf_hash)) return;
  sentRegistrations.add(params.cpf_hash);

  queuePush({
    type: EInsiderQueueType.custom_event,
    value: [{
      event_name: 'campaign-voucher_registration',
      event_parameters: {
        cpf_hash: params.cpf_hash,
        campaign_name: params.campaign_name,
        consent_terms: params.consent_terms,
        consent_notification: params.consent_notification,
        event_date: new Date().toISOString(),
      },
    }],
  });
  queueCommit();
}

/**
 * Track campaign-voucher_reservation event.
 */
export function trackVoucherReservation(params: ReservationEventParams): void {
  if (!insiderConfig.enabled) return;
  if (sentReservations.has(params.voucher_id)) return;
  sentReservations.add(params.voucher_id);

  queuePush({
    type: EInsiderQueueType.custom_event,
    value: [{
      event_name: 'campaign-voucher_reservation',
      event_parameters: {
        voucher_id: params.voucher_id,
        reservation_date: params.reservation_date,
        redemption_date: params.redemption_date,
        redemption_datetime: params.redemption_date,
        store_code: params.store_code,
        store_name: params.store_name,
        campaign_name: params.campaign_name,
        event_date: new Date().toISOString(),
      },
    }],
  });
  queueCommit();
}
